<template>
  <div class="row">
    <div class="col-md-12">
      <div class="row" v-if="showChangeMasterDomain()">
        <div class="col-md-12 pb-4">
          <ChangeMasterDomain :is-primary-site="isPrimarySite()" :site="site" />
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 pb-4">
          <PointerDomainsTable :site="site" :pointer-domains="pointerDomains" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, onMounted } from "@vue/composition-api";
import ChangeMasterDomain from "@/components/smart/cards/ChangeMasterDomain";
import PointerDomainsTable from "@/components/smart/tables/PointerDomainsTable";
import store from "@/store";

export default {
  name: "SiteDomainOptionsPage",
  components: { ChangeMasterDomain, PointerDomainsTable },
  setup() {
    const plan = computed(() => store.getters["plans/getItem"]);
    const site = computed(() => store.getters["sites/getItem"]);
    const pointerDomains = computed(() => store.state.pointerDomains);

    const isLWy = () => !plan.value?.isTShirt;
    const isPrimarySite = () => site.value?.id === plan.value?.cloudAccount?.id;
    const showChangeMasterDomain = () => isLWy() || isPrimarySite();

    onMounted(() => {
      store.dispatch("pointerDomains/getList", site.value.id);
    });

    return {
      isPrimarySite,
      plan,
      pointerDomains,
      site,
      showChangeMasterDomain,
    };
  },
};
</script>
